import { ReactNode } from "react";
import Link from "../Link";

interface Props {
  title: string;
  description: string;
  actionLabel?: string;
  actionTo?: string;
  icon?: ReactNode;
}

export default function EmptyState(props: Props) {
  const { title, description, actionLabel, actionTo, icon } = props;

  return (
    <div className="flex flex-col items-center rounded-2xl border border-dashed border-border bg-white px-6 py-14 text-center shadow-sm">
      {icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primaryLight text-primary">
          {icon}
        </div>
      )}
      <h2 className="text-lg font-bold text-gray">{title}</h2>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-muted">
        {description}
      </p>
      {actionLabel && actionTo && (
        <Link className="mt-6 !w-fit" to={actionTo}>
          {actionLabel}
        </Link>
      )}
    </div>
  );
}
